module.exports = __webpack_public_path__ + "static/media/mobileScreenshot01.2181677b.jpg";